(()=>{
    class e extends HTMLElement {
        constructor() {
            super()
        }
        show() {
            this.classList.remove("uk-hidden")
        }
        hide() {
            this.classList.add("uk-hidden")
        }
    }
    class s extends HTMLElement {
        constructor() {
            super(),
            this.addEventListener("click", e=>{
                const t = document.createElement("input");
                t.value = e.target.dataset.discount||document.querySelector('.tm-discount').dataset.discount,
                document.body.appendChild(t),
                t.select(),
                document.execCommand("Copy"),
                t.remove(),
                UIkit.notification({
                    message: "Copied",
                    pos: "center",
                    status: "success"
                })
            }
            )
        }
    }
    customElements.define("discount-component", s);
    class i extends HTMLElement {
        constructor() {
            super(),
            this.isScrollMode = this.id === "js-filter-product" || this.hasAttribute("data-tab-scroll"),
            this.isScrollMode ? this.showAllSections() : (this.updateSections(),
            this.initFilterTabs())
        }
        showAllSections() {
            document.querySelectorAll("[data-filter]").forEach(e=>e.classList.remove("uk-hidden"))
        }
        initFilterTabs() {
            this.querySelectorAll("[data-filter-tab]").forEach(e=>{
                e.addEventListener("click", e=>{
                    e.target.closest("ul").querySelectorAll("li").forEach(e=>e.classList.remove("tm-active")),
                    e.target.closest("li").classList.add("tm-active"),
                    this.updateSections(e.target.dataset.filterTab)
                }
                , !1)
            }
            )
        }
        updateSections(e) {
            e = e || "group_1";
            document.querySelectorAll("[data-filter]").forEach(e=>e.classList.add("uk-hidden")),
            document.querySelectorAll(`[data-filter="${e}"]`).forEach(e=>e.classList.remove("uk-hidden"))
        }
    }
    customElements.define("tab-filter", i);
}
)();
